import { useEffect } from "react";
import LegalPageLayout from "@/components/LegalPageLayout";

export default function Termini() {
  useEffect(() => {
    document.title = "Termini di Servizio · InPalmo";
  }, []);

  return (
    <LegalPageLayout title="Termini di Servizio" lastUpdate="aggiornati a Febbraio 2026">
      <div
        data-testid="terms-placeholder-banner"
        className="not-prose p-4 rounded-xl bg-[#FDF6E3] border border-[#F2DEB0] text-sm text-[#8B6518]"
      >
        ⚠️ <strong>Beta chiusa e gratuita.</strong> InPalmo è attualmente in fase di beta test su
        invito. Il servizio è offerto da una <strong>persona fisica</strong> senza P.IVA e senza
        alcun corrispettivo. Se in futuro verrà introdotta una fatturazione, i presenti Termini
        verranno aggiornati con almeno 30 giorni di preavviso.
      </div>

      <p>
        I presenti Termini disciplinano l&apos;utilizzo di <strong>InPalmo</strong> (in seguito,
        &quot;il Servizio&quot;), reso disponibile da <strong>Giuseppe De Masi</strong>, persona fisica
        residente in Italia (in seguito, &quot;il Fornitore&quot;), come progetto personale in fase di
        beta test chiusa e gratuita. Utilizzando il Servizio dichiari di averli letti, compresi e
        accettati.
      </p>

      <h2>1. Oggetto del Servizio</h2>
      <p>
        InPalmo è un&apos;applicazione web di gestione del magazzino pensata per piccoli negozi
        alimentari, gastronomie, salumerie e banchi di frutta e verdura. Le funzionalità
        includono, a titolo non esaustivo: scansione di scontrini e DDT tramite intelligenza
        artificiale, gestione di scadenze e giacenze, notifiche, riordino fornitori, dashboard di
        vendita ed esportazione dati.
      </p>

      <h2>2. Account e responsabilità dell&apos;utente</h2>
      <ul>
        <li>
          L&apos;accesso alla beta avviene tramite <strong>codice invito</strong> personale +{" "}
          <strong>Google Sign-In</strong>. L&apos;utente è responsabile della sicurezza del proprio
          account Google e della riservatezza del codice invito ricevuto.
        </li>
        <li>
          L&apos;utente garantisce la correttezza dei dati forniti e si impegna ad aggiornarli quando
          necessario.
        </li>
        <li>
          L&apos;utente è responsabile dell&apos;uso dell&apos;account da parte dei propri collaboratori (es.
          cassieri) invitati a far parte del team.
        </li>
      </ul>

      <h2>3. Uso accettabile</h2>
      <p>L&apos;utente si impegna a non:</p>
      <ul>
        <li>utilizzare il Servizio per attività illecite o in violazione di diritti di terzi;</li>
        <li>caricare contenuti che violino il diritto d&apos;autore o la privacy altrui;</li>
        <li>
          tentare di accedere indebitamente ai sistemi o ai dati di altri utenti, eseguire reverse
          engineering, scraping massivo o attività che compromettano la stabilità del Servizio;
        </li>
        <li>rivendere, sub-licenziare o concedere a terzi l&apos;accesso al proprio account.</li>
      </ul>

      <h2>4. Gratuità e beta</h2>
      <ul>
        <li>
          Nella fase attuale il Servizio è offerto <strong>gratuitamente</strong> agli utenti in
          possesso di un codice invito valido. Nessun pagamento è richiesto né dovuto.
        </li>
        <li>
          Trattandosi di una beta, alcune funzionalità potrebbero essere instabili, cambiare o
          essere rimosse senza preavviso.
        </li>
        <li>
          Se in futuro il Fornitore deciderà di introdurre un piano a pagamento, gli utenti attivi
          verranno avvisati con almeno 30 giorni di anticipo e potranno decidere se proseguire o
          cancellare l&apos;account. Gli utenti attivati con un codice invito &quot;comp&quot; (accesso
          gratuito a vita) resteranno esenti da eventuali costi futuri.
        </li>
      </ul>

      <h2>5. Cancellazione dell&apos;account</h2>
      <p>
        L&apos;utente può richiedere la <strong>cancellazione completa dell&apos;account</strong> e di
        tutti i dati associati direttamente dalla pagina <em>Impostazioni → Account</em>. La
        cancellazione include profilo Google, negozio, prodotti, vendite, fornitori, impostazioni
        e log invii email (vedi §7 dell&apos;informativa Privacy per il dettaglio completo).
      </p>

      <h2>6. Dati dell&apos;utente</h2>
      <p>
        I dati inseriti nel Servizio (prodotti, vendite, fornitori, ecc.) sono e restano di
        proprietà esclusiva dell&apos;utente. Il Fornitore agisce in qualità di responsabile del
        trattamento ai sensi dell&apos;art. 28 GDPR e si impegna a non utilizzare tali dati per
        finalità diverse da quelle necessarie a erogare il Servizio.
      </p>

      <h2>7. Disponibilità del Servizio</h2>
      <p>
        Il Fornitore si impegna a mantenere il Servizio disponibile con una <em>best effort</em>{" "}
        operativa, riservandosi periodiche finestre di manutenzione di norma comunicate in
        anticipo. Trattandosi di beta gratuita, il Servizio è erogato &quot;così com&apos;è&quot; e &quot;secondo
        disponibilità&quot;, senza garanzie di operatività al 100%. Eventuali malfunzionamenti non
        costituiscono inadempimento, salvo quanto inderogabilmente previsto dalla normativa
        applicabile.
      </p>

      <h2>8. Limitazione di responsabilità</h2>
      <p>
        Nei limiti consentiti dalla legge, il Fornitore non risponde di eventuali danni indiretti,
        perdite di dati, perdite di profitti, mancata operatività o interruzioni del Servizio.
        Poiché il Servizio è offerto gratuitamente in fase di beta, la responsabilità complessiva
        del Fornitore è esclusa nella massima misura consentita dalla legge, ferme restando le
        tutele inderogabili previste dalla normativa italiana ed europea a favore del consumatore.
      </p>

      <h2>9. Sospensione e chiusura del Servizio</h2>
      <p>
        Il Fornitore può sospendere o chiudere il Servizio in qualsiasi momento, in particolare al
        termine della fase beta o in caso di gravi violazioni dei presenti Termini. In caso di
        chiusura definitiva, gli utenti avranno almeno 30 giorni di preavviso per esportare i
        propri dati (funzione <em>Impostazioni → Esporta i miei dati</em>).
      </p>

      <h2>10. Proprietà intellettuale</h2>
      <p>
        Tutti i diritti di proprietà intellettuale relativi al Servizio (codice sorgente,
        interfacce, marchio &quot;InPalmo&quot;, logo, contenuti) sono di proprietà esclusiva del
        Fornitore. È concessa all&apos;utente una licenza personale, non esclusiva e non trasferibile
        per il solo uso del Servizio nell&apos;ambito della propria attività.
      </p>

      <h2>11. Modifiche ai Termini</h2>
      <p>
        Il Fornitore può aggiornare i presenti Termini per ragioni tecniche, legali o
        organizzative (ad esempio: passaggio da beta a piano a pagamento, apertura di P.IVA,
        introduzione di nuovi subfornitori). Le modifiche sostanziali verranno comunicate via
        email e/o tramite avviso in-app con almeno 30 giorni di anticipo. La prosecuzione
        dell&apos;utilizzo del Servizio dopo l&apos;entrata in vigore equivale ad accettazione.
      </p>

      <h2>12. Legge applicabile e foro competente</h2>
      <p>
        Il rapporto è regolato dalla <strong>legge italiana</strong>. Per qualsiasi controversia
        il foro competente in via esclusiva è quello del luogo di residenza del Fornitore, fatte
        salve le inderogabili previsioni di legge a tutela del consumatore.
      </p>

      <h2>13. Contatti</h2>
      <p>
        Per ogni questione relativa al Servizio:{" "}
        <a href="mailto:ciao@inpalmo.it">ciao@inpalmo.it</a>.
      </p>
    </LegalPageLayout>
  );
}
